"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensPanel = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Types_1 = require("Tokens/Types");
var DataTransferTypes_1 = require("CommonUI/DragDrop/DataTransferTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var CrmTokensTab_1 = require("./CrmTokensTab");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var CustomTokensTab_1 = require("./CustomTokensTab");
var TokenList_1 = require("./TokenList");
var TokenListItem_1 = require("./TokenListItem");
var TokensPanelFrame_1 = __importDefault(require("./TokensPanelFrame/TokensPanelFrame"));
var TokenLinking_1 = require("Project/Actions/Tokens/LinkToken/TokenLinking");
var TelemetryTypes_1 = require("@CommonFrontendBackend/Tokens/TelemetryTypes");
var TokenReplacement_1 = require("Project/Actions/Tokens/TokenReplacement/TokenReplacement");
var lodash_1 = require("lodash");
var TOKEN_LIST_HEIGHT = 380;
var TOKEN_LIST_ITEM_HEIGHT = 40;
var TokensPanel = (function (_super) {
    __extends(TokensPanel, _super);
    function TokensPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCrmPopularTokens = function () {
            return _this.props.tokenViewStore.popularCrmTokens.map(function (token, i) {
                return _this.renderTokenListItem(token, "popular-token-".concat(i));
            });
        };
        _this.renderTokenList = function (props) {
            var tokenViewStore = _this.props.tokenViewStore;
            return (react_1.default.createElement(TokenList_1.TokenList, __assign({}, props, { isLoading: tokenViewStore.isLoading, tokens: tokenViewStore.tokens, listHeight: TOKEN_LIST_HEIGHT, listItemHeight: TOKEN_LIST_ITEM_HEIGHT, renderListItem: _this.renderTokenListItem, renderEmptyState: _this.renderTokenListEmptyState })));
        };
        _this.renderTokenListItem = function (token, key) {
            var _a = _this.props, tokenViewStore = _a.tokenViewStore, usingFeature = _a.usingFeature, isUserAdmin = _a.isUserAdmin;
            var isEditable = (0, Types_1.isTokenEditable)(token);
            var isList = usingFeature(FeatureFlag_1.FeatureFlag.PublicApi) && (0, Types_1.isListToken)(token) && token !== tokenViewStore.selectedListToken;
            var canUpdateToken = isEditable && isUserAdmin;
            if (isList && (0, Types_1.isListToken)(token)) {
                return (react_1.default.createElement(TokenListItem_1.TokenListItem, { key: key, token: token, onDelete: canUpdateToken ? tokenViewStore.deleteToken : undefined, onShowProperties: tokenViewStore.toggleSelectedListToken },
                    react_1.default.createElement(kaleidoscope_1.Token, { name: token.name, type: "list", isDraggable: true, onDragStart: function (e) { return _this.onDragToken(e, token); }, onDragEnd: _this.onDragEndToken })));
            }
            else if ((0, Types_1.isPopularToken)(token) && !("id" in token)) {
                return (react_1.default.createElement(TokenListItem_1.TokenListItem, { key: key, token: token },
                    react_1.default.createElement(kaleidoscope_1.Token, { name: token.name, type: isList ? "list" : "text", isDraggable: true, onDragStart: function (e) { return _this.onDragToken(e, token); }, onDragEnd: _this.onDragEndToken })));
            }
            else {
                return (react_1.default.createElement(TokenListItem_1.TokenListItem, { key: key, token: token, onDelete: canUpdateToken ? tokenViewStore.deleteToken : undefined },
                    react_1.default.createElement(kaleidoscope_1.Token, { name: token.name, type: isList ? "list" : "text", isDraggable: true, onDragStart: function (e) { return _this.onDragToken(e, token); }, onDragEnd: _this.onDragEndToken })));
            }
        };
        _this.renderTokenListEmptyState = function () {
            var tokenViewStore = _this.props.tokenViewStore;
            return (react_1.default.createElement("div", { className: "tokens-panel__tokens-list-empty" },
                react_1.default.createElement("div", { className: "tokens-panel__tokens-list-empty-label" }, tokenViewStore.errorMessage ? tokenViewStore.errorMessage : "No matching tokens")));
        };
        _this.openChangeTokenLinking = function () {
            var _a, _b, _c, _d;
            var _e = _this.props, modal = _e.modal, tokenReplacementStore = _e.tokenReplacementStore, projectStore = _e.projectStore, tokenIntegrations = _e.tokenIntegrations;
            tokenReplacementStore.setCrmObject((_b = (_a = projectStore.crmInfo) === null || _a === void 0 ? void 0 : _a.object) !== null && _b !== void 0 ? _b : null);
            tokenReplacementStore.setProviderType((_d = (_c = projectStore.crmInfo) === null || _c === void 0 ? void 0 : _c.integration) !== null && _d !== void 0 ? _d : null);
            modal.showSimpleModal({
                body: (react_1.default.createElement(TokenLinking_1.TokenLinking, { closeModal: function () {
                        modal.closeAnyModals();
                    }, openTokenReplacementModal: _this.openTokenReplacementModal, currentCrmObjectType: tokenReplacementStore.crmObjectType, currentProviderType: tokenReplacementStore.providerType, tokenIntegrations: tokenIntegrations, tokenReplacementStore: tokenReplacementStore })),
            });
        };
        _this.openTokenReplacementModal = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, modal, tokenReplacementStore, projectStore, tokenStore, telemetry, existingTokensFriendlyName, existingTokensProvider, crmType, integrationMetadata, crmObjectType;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, modal = _a.modal, tokenReplacementStore = _a.tokenReplacementStore, projectStore = _a.projectStore, tokenStore = _a.tokenStore, telemetry = _a.telemetry;
                        if ((_b = projectStore.crmInfo) === null || _b === void 0 ? void 0 : _b.connected) {
                            crmType = projectStore.crmInfo.integration;
                            integrationMetadata = Types_2.INTEGRATION_METADATA.get(projectStore.crmInfo.integration);
                            crmObjectType = projectStore.crmInfo.object;
                            existingTokensFriendlyName = "".concat(integrationMetadata.displayName, " ").concat((0, lodash_1.capitalize)(crmObjectType));
                            existingTokensProvider = "".concat(crmType, "_").concat(crmObjectType);
                        }
                        else {
                            existingTokensFriendlyName = "account";
                            existingTokensProvider = "custom";
                        }
                        telemetry.trackOnly(TelemetryTypes_1.TokensEvents.TokenSwapViewed, {
                            incoming_provider: existingTokensProvider,
                            outgoing_provider: "".concat(tokenReplacementStore.providerType, "_").concat(tokenReplacementStore.crmObjectType),
                            token_count: tokenReplacementStore.countTokens,
                        }, { blockIntercom: true });
                        return [4, modal.showSimpleModal({
                                containerClassName: "token-replacement-modal",
                                body: (react_1.default.createElement(TokenReplacement_1.TokenReplacement, { closeModal: modal.closeAnyModals, existingTokensFriendlyName: existingTokensFriendlyName, tokenReplacementStore: tokenReplacementStore })),
                            })];
                    case 1:
                        _c.sent();
                        return [2];
                }
            });
        }); };
        return _this;
    }
    TokensPanel.prototype.onDragToken = function (event, token) {
        event.dataTransfer.setData(DataTransferTypes_1.VariableDataTransferFormat.Json, JSON.stringify(token));
        this.props.dragStore.startDrag({
            type: DragStore_1.DragType.Variable,
            id: "".concat(token.providerType, "-").concat(token.apiName),
            token: token,
        });
    };
    TokensPanel.prototype.onDragEndToken = function () {
        this.props.dragStore.stopDrag();
    };
    TokensPanel.prototype.createTabOnClick = function (type) {
        var _this = this;
        return function () {
            _this.props.tokenViewStore.onTabChange(type);
        };
    };
    TokensPanel.prototype.componentDidMount = function () {
        this.props.tokenViewStore.fetchSearchResults();
    };
    TokensPanel.prototype.render = function () {
        var tokenViewStore = this.props.tokenViewStore;
        return tokenViewStore.showListTokenProperties
            ? this.renderListTokenPropertiesPanel()
            : this.renderTokensSearchPanel();
    };
    TokensPanel.prototype.renderTokensSearchPanel = function () {
        var tokenViewStore = this.props.tokenViewStore;
        return react_1.default.createElement(TokensPanelFrame_1.default, { tokenViewStore: tokenViewStore }, this.renderTokensTabs());
    };
    TokensPanel.prototype.renderTokensTabs = function () {
        var _a;
        var _b = this.props, tokenViewStore = _b.tokenViewStore, projectStore = _b.projectStore;
        return (react_1.default.createElement(kaleidoscope_1.Tabs, { initialIndex: tokenViewStore.activeTabIndex },
            react_1.default.createElement(kaleidoscope_1.TabList, { className: "tokens-panel__tab-list", "aria-label": "Token tabs", isBordered: true },
                react_1.default.createElement(kaleidoscope_1.Tab, { key: Types_2.TokenType.Custom, onClick: this.createTabOnClick(Types_2.TokenType.Custom) }, "Account"),
                tokenViewStore.showCrmTab && (react_1.default.createElement(kaleidoscope_1.Tab, { key: Types_2.TokenType.Crm, onClick: this.createTabOnClick(Types_2.TokenType.Crm) }, ((_a = Types_2.INTEGRATION_METADATA.get(projectStore.crmInfo.integration)) === null || _a === void 0 ? void 0 : _a.displayName) || "CRM"))),
            react_1.default.createElement(kaleidoscope_1.TabPanels, null,
                react_1.default.createElement(kaleidoscope_1.TabPanel, { key: Types_2.TokenType.Custom }, this.renderCustomTokensTabPanel()),
                tokenViewStore.showCrmTab && react_1.default.createElement(kaleidoscope_1.TabPanel, { key: Types_2.TokenType.Crm }, this.renderCrmTokensTabPanel()))));
    };
    TokensPanel.prototype.renderListTokenPropertiesPanel = function () {
        var tokenViewStore = this.props.tokenViewStore;
        var listToken = tokenViewStore.selectedListToken;
        var onAddToken = function (name) {
            return tokenViewStore.addListTokenProperty(listToken, name);
        };
        var onChangeLabel = function (label) {
            return tokenViewStore.updateListTokenChildPropertyLabel(listToken, label);
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "tokens-panel__header" },
                react_1.default.createElement("div", { className: "tokens-panel__properties-header" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, { className: "tokens-panel__back-btn", type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.ArrowLeft, null), onClick: function () { return tokenViewStore.toggleSelectedListToken(null); } }),
                    react_1.default.createElement("h2", { className: "tokens-panel__properties-title" }, "Repeating item properties")),
                react_1.default.createElement(CustomTokensTab_1.AddListTokenPropertyForm, { initialLabel: listToken.childPropertyLabel, onLabelChange: onChangeLabel, onAddToken: onAddToken })),
            this.renderTokenList({
                className: "tokens-panel__properties-list",
                startElement: this.renderTokenListItem(tokenViewStore.selectedListToken),
            })));
    };
    TokensPanel.prototype.renderCustomTokensTabPanel = function () {
        var _a = this.props, tokenViewStore = _a.tokenViewStore, projectStore = _a.projectStore, usingFeature = _a.usingFeature, isUserAdmin = _a.isUserAdmin;
        var isDisabled = projectStore.isCrmTemplate;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)({ "tokens-panel__tab--disabled": isDisabled }) },
            isDisabled && (react_1.default.createElement("div", { className: "tokens-panel__tab-disabled-overlay" },
                react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Account tokens not supported", theme: kaleidoscope_1.AlertTheme.Dark },
                    "Account tokens are currently not supported with the ",
                    tokenViewStore.connectedIntegrationProviderName,
                    " ",
                    "integration."))),
            this.renderTokenList({
                startElement: isUserAdmin && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(CustomTokensTab_1.AddTokenForm, { onAddToken: tokenViewStore.addToken, allowListTokens: usingFeature(FeatureFlag_1.FeatureFlag.PublicApi) }))),
            })));
    };
    TokensPanel.prototype.renderCrmTokensTabPanel = function () {
        var _a = this.props, tokenIntegrations = _a.tokenIntegrations, projectStore = _a.projectStore, tokenViewStore = _a.tokenViewStore, isUserAdmin = _a.isUserAdmin;
        var getIntegrationSettingsUrl = function () { return "/#/settings/integrations"; };
        var getHelpArticleUrl = function () { return "https://help.qwilr.com/article/374-beta-crm-template-tokens"; };
        if (tokenIntegrations.integrations.length === 0) {
            return (react_1.default.createElement(CrmTokensTab_1.CrmIntegrationSetup, { getHelpArticleUrl: getHelpArticleUrl, getIntegrationSettingsUrl: getIntegrationSettingsUrl }));
        }
        else if (!projectStore.isCrmTemplate) {
            return react_1.default.createElement(CrmTokensTab_1.CrmTemplateSetup, { onAddToCrm: this.openChangeTokenLinking, getHelpArticleUrl: getHelpArticleUrl });
        }
        else {
            var integrationMetadata = Types_2.INTEGRATION_METADATA.get(projectStore.crmInfo.integration);
            return (react_1.default.createElement(react_1.default.Fragment, null,
                this.renderTokenList({
                    startElement: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "tokens-panel__tokens-group" },
                            isUserAdmin && (react_1.default.createElement("div", { className: "tokens-panel__integration-header" },
                                react_1.default.createElement("div", { className: "tokens-panel__integration-name" }, (0, lodash_1.capitalize)("".concat(integrationMetadata === null || integrationMetadata === void 0 ? void 0 : integrationMetadata.displayName, " ").concat(projectStore.crmInfo.object))),
                                react_1.default.createElement(kaleidoscope_1.Button, { className: "tokens-panel__integration-change-btn", type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: this.openChangeTokenLinking }, "Change"))),
                            tokenViewStore.showPopularCrmTokens && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("div", { className: "tokens-panel__tokens-group-title" }, "Popular"),
                                this.renderCrmPopularTokens()))),
                        tokenViewStore.showPopularCrmTokens && (react_1.default.createElement("div", { className: "tokens-panel__tokens-group-title" }, "All tokens")))),
                }),
                (integrationMetadata === null || integrationMetadata === void 0 ? void 0 : integrationMetadata.hasCustomFields) && (react_1.default.createElement("div", { className: "tokens-panel__footer" },
                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, "Can't find a token? "),
                    react_1.default.createElement(kaleidoscope_1.Text, null,
                        "Check ", integrationMetadata === null || integrationMetadata === void 0 ? void 0 :
                        integrationMetadata.displayName,
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/integrations/".concat(projectStore.crmInfo.integration) }, "Custom Fields"))))));
        }
    };
    var _a, _b, _c;
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _a : Object, Object]),
        __metadata("design:returntype", void 0)
    ], TokensPanel.prototype, "onDragToken", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokensPanel.prototype, "onDragEndToken", null);
    TokensPanel = __decorate([
        mobx_react_1.observer
    ], TokensPanel);
    return TokensPanel;
}(react_1.default.Component));
exports.TokensPanel = TokensPanel;
